<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog process-show-dialog"
  >  
  <v-card elevation="0" class="result-card">
    <v-col class="text-right px-4">
      <v-btn icon @click="closeDialog">
        <v-icon large color="primary">close</v-icon>
      </v-btn>
    </v-col>

    <v-card-text>
      <v-form ref="form" v-if="dialog">

             <!-- Quick-Overview CardBar -->
              <v-row justify="center" class="mb-3">
                <!-- md="10" -->
                <v-col cols="12" sm="8" md="8" class="pa-0">
                  <TaskCard
                    :taskName="taskListItem.processName"
                    :additionalNames="getAdditionalNames(taskListItem)"
                    :taskStatus="taskListItem.taskStatus"            
                    :period="computedPeriod(taskListItem)"
                    :accepted="taskListItem.accepted"
                    :username="taskListItem.assignedToName"
                    :hide-user="hideUser"
                  /> 
                </v-col>
              </v-row>       
      
              <!-- More specific Overview-Card -->
              <v-row justify="center" >
                <!-- sm="6" md="5" -->
                <v-col cols="12" sm="8" md="8" class="overview-card pa-5">
                  <!-- Section General -->
                  <h4 class="primary--text font-weight-medium">{{ $t('common:general') }}</h4>

                  <!-- Process Name -->
                  <LabelField
                      :label="$t('common:process')"
                      :value="taskListItem.processName"
                  />

                  <!-- Facility Name -->
                  <LabelField
                      :label="$t('common:facility')"
                      :value="taskListItem.facilityName"
                  />

                  <!-- Building Name -->
                  <LabelField
                      :label="$t('common:building')"
                      :value="taskListItem.buildingName"
                  />
                  
                  <!-- start Date -->
                  <LabelField
                      :label="$t('common:start-date')"
                      :value="computedStartDateFormatted"
                  />

                  <!-- end Date -->
                  <LabelField
                      :label="$t('common:end-date')"
                      :value="computedEndDateFormatted"
                  />

                  <!-- assignedTo -->
                  <LabelField
                      v-if="taskListItem.assignedToName"
                      :label="$t('components:process-result-dialog.labels.done-by-user')"
                      :value="taskListItem.assignedToName"
                  />

                  <v-checkbox
                      disabled
                      color="secondary"
                      v-model="taskListItem.signatureRequired"
                      :label="$t('common:gets-signed')"
                      tabindex="78"
                  />

                </v-col>               
              </v-row>
              <v-row justify="center">
                <v-col cols="8" md="8" class="px-0">
                   <h4 class="primary--text font-weight-medium mt-5">{{ $t('components:process-result-dialog.titles.overview') }}</h4>
                    <v-expansion-panels tile flat v-model="openedPanel">
                      <v-expansion-panel v-for="item in this.processSteps" :key="item.id" class="mb-2">
                         <!-- Panel Header -->
                        <v-expansion-panel-header :class="'pa-3 border-left-success--' + item.success">
                          <v-row justify="space-between" align="center">
                            <v-col class="py-0">
                              <v-row no-gutters>                               
                                <!-- Process Step name -->
                                <h6 class="mb-0 pt-2 ml-2 greyDark--text">{{ item.name }}</h6>
                              </v-row>
                            </v-col>                           
                          </v-row>
                        </v-expansion-panel-header>

                        <!-- Panel Body -->
                        <v-expansion-panel-content class="mt-2">
                          <p>{{ item.description }}</p>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
            </v-form>
    </v-card-text>
  </v-card>
  </v-dialog>
</template>

<script>

import LabelField from "@/modules/core/components/LabelField";
import TaskCard from "@/modules/book/components/TaskCard/TaskCard";
import DataUtils from "@/modules/core/services/data-utils";
import ProcessStep from '@/modules/book/data/processStep'
import ProcessService from '@/modules/book/services/process/impl/process-service'
import Utils from "@/modules/core/services/utils";

  export default {
    name: 'ProcessShowDialog',
    components: {
      LabelField,
      TaskCard
    },
    props: {
      hideUser: Boolean // if user in taskcard should be hidden
    },
    data() {
      return {        
        dialog: false,
        isFetchingtaskListItem: true,
        taskListItem: null,       
        processSteps: [],
        openedPanel: null
      }
    },
    methods: {
      getProcessSteps(itemId) {
        
        ProcessService.readProcessStepsFromAPI(itemId,
        (resp) => {
          this.processSteps = DataUtils.parseDataToObjectArray(resp.data, ProcessStep);   
          this.dialog = true;       
        },        
        () => {          
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('components:process-result-dialog.processStep')}))
        })        
      },
      closeDialog() {
        this.dialog = false
      },
      openDialog(taskListItem) {
        if (taskListItem.taskStatus != 'job-open-valid' &&
            taskListItem.taskStatus != 'job-open-invalid' &&
            taskListItem.taskStatus != 'job-accepted-valid' &&
            taskListItem.taskStatus != 'job-accepted-invalid' &&
            taskListItem.taskStatus != 'job-accepted-future' &&
            taskListItem.taskStatus != 'job-not-accepted-future')
        return;//dialog won't open

        this.taskListItem = taskListItem;                     
        
        this.getProcessSteps(taskListItem.processId);
      },
      getAdditionalNames(taskListItem) {
        return [
          {name: taskListItem.buildingName, asButton: false},
          {name: taskListItem.facilityName, asButton: false}
        ];
      }
    },
    computed: {
      computedStartDateFormatted() {        
        return this.taskListItem.startDate;
      },
      computedEndDateFormatted() {
        return this.taskListItem.endDate;
      },
      computedPeriod() {
        return taskListItem => (taskListItem.startDate && taskListItem.endDate) ? taskListItem.startDate + ' - ' + taskListItem.endDate : '';
      }
    },
  }
</script>

<style lang="scss">
.process-show-dialog {
  /*
  had to set z-index of dialog and overlay manually here
  because here we have a single case of dialog over dialog
*/
  .v-dialog__content.v-dialog__content--active {
    z-index: 500 !important;
  }

  .overview-card {
    background-color: #fff;
  }

  .result-card {
    background-color: rgba(246, 247, 255, 0.97)!important;
  }

  .border-left-success--true {
    border-left: 5px solid var(--v-scaleGreen-base)!important;
  }

  .border-left-success--false {
    border-left: 5px solid var(--v-scaleRed-base)!important;
  }

  .v-expansion-panel {
    background-color: transparent!important;

    .v-expansion-panel-header {
      background-color: #fff;
    }

    .v-expansion-panel-content {
      background-color: #fff;

      .v-expansion-panel-content__wrap {
        padding: 16px 24px;
      }
    }
  }
}
</style>